import PropTypes from 'prop-types';
import { useState } from 'react';

export default function DownloadOrViewPdf({ opts, fileName, handleDownloadOrView, showIcon }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleMenuItemClick = async (isView = false) => {
    setIsLoading(true);
    await handleDownloadOrView(opts, fileName, isView);
    setIsLoading(false);
  };

  return (
    <>
      <span
        className="p-button p-button-text p-button-sm w-fit mt-1 p-0"
        onClick={() => handleMenuItemClick(true)}
      >
        {showIcon && (
          <>
            <i className="pi pi-file-pdf text-red-500 text-xl" />{' '}
          </>
        )}
        <span className="text-blue-500 underline font-italic text-base ml-2">
          {isLoading ? <i className="pi pi-spin pi-spinner ml-2" /> : fileName}
        </span>
      </span>
      {/* <Menu
        ref={downloadRef}
        model={[
          {
            label: t('council.review.downloadPdfTemplate'),
            icon: 'pi pi-file-pdf',
            command: () => handleMenuItemClick(),
            disabled: isLoading,
          },
          {
            label: t('council.review.viewPdf'),
            icon: 'pi pi-eye',
            command: () => handleMenuItemClick(true),
            disabled: isLoading,
          },
        ]}
        popup
        popupAlignment="right"
      /> */}
    </>
  );
}

DownloadOrViewPdf.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    fileUrl: PropTypes.string,
    filename: PropTypes.string,
  }),
  fileName: PropTypes.string.isRequired,
  handleDownloadOrView: PropTypes.func.isRequired,
  showIcon: PropTypes.bool,
};

DownloadOrViewPdf.defaultProps = {
  opts: {
    id: null,
    fileUrl: null,
    filename: null,
  },
  showIcon: true,
};
